import {combineReducers} from "redux";
import uploadApk from "./uploadApk";
import userConfig from "./userConfig";
import activityLog from "./activityLog";

const otherSettingReducer = combineReducers({
    uploadApk,
    userConfig,
    activityLog
});

export default otherSettingReducer;
